import type { NDateLocale } from './enUS'
import { km } from 'date-fns/locale'

const dateKmKH: NDateLocale = {
  name: 'km-KH',
  locale: km
}

export default dateKmKH
